const divCalendarModalFilter = {
  label: 'Filter by',
  closeModal: 'CANCEL',
  done: 'APPLY'
};

export default divCalendarModalFilter;
